import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import {
  AlipayPaymentResult,
  BpayWechatQrPayment,
  UserLogin,
  UserRegister,
  UserDashboard,
  UserVerifyEmail,
  PaymentForm,
  BPayPaymentForm,
  AUBridgePaymentForm,
  LexusSalesPaymentForm,
  LexusServicePaymentForm,
  KnoxPaymentForm,
  TrinityKewPaymentForm,
  OxleyPaymentForm,
  PaytoPaymentForm,
  KMPPaymentForm,
  CodeHQPaymentForm,
  HMPaymentForm,
  SarafiHaidariDandenongPaymentForm,
  AmalFootscrayPaymentForm,
  OligoPayPaymentForm,
  XeroUserAuthRedirect,
  XeroUserAuthDashboard,
} from './BPay/page';
import { LoadingBar } from './BPay/components';
import { Infrastructure } from './infrastructure';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Infrastructure>
    <LoadingBar />
    <Router>
      <Routes>
        <Route
          path="/bpay/wechat-qr-payment"
          element={<BpayWechatQrPayment />}
        />
        <Route
          path="/bpay/alipay-result-page"
          element={<AlipayPaymentResult />}
        />
        <Route path="/user/login" element={<UserLogin />} />
        <Route path="/user/register" element={<UserRegister />} />
        <Route path="/user/dashboard" element={<UserDashboard />} />
        <Route path="/user/verify-email" element={<UserVerifyEmail />} />
        <Route path="/bpay-flow" element={<BPayPaymentForm />} />
        <Route path="/aubridge-flow" element={<AUBridgePaymentForm />} />
        <Route path="/lexus-sales" element={<LexusSalesPaymentForm />} />
        <Route path="/lexus-service" element={<LexusServicePaymentForm />} />
        <Route path="/knox-pay" element={<KnoxPaymentForm />} />
        <Route path="/oxley-pay" element={<OxleyPaymentForm />} />
        <Route path="/payto-pay" element={<PaytoPaymentForm />} />
        <Route path="/trinitykew-pay" element={<TrinityKewPaymentForm />} />
        <Route path="/kmp-pay" element={<KMPPaymentForm />} />
        <Route path="/codehq-pay" element={<CodeHQPaymentForm />} />
        <Route path="/hm-pay" element={<HMPaymentForm />} />
        <Route path="/sarafi-dandenong-pay" element={<SarafiHaidariDandenongPaymentForm />} />
        <Route path="/amal-footscray-pay" element={<AmalFootscrayPaymentForm />} />
        <Route path="/oligo-pay" element={<OligoPayPaymentForm />} />
        <Route path="/xero/user-auth-dashboard" element={<XeroUserAuthDashboard />} />
        <Route path="/xero/user-auth-redirect" element={<XeroUserAuthRedirect />} />
        <Route path="*" element={<PaymentForm />} /> {/* Default route */}
      </Routes>
    </Router>
  </Infrastructure>
);
